
// @flow
import React, {memo, useEffect, useState} from 'react';
import {Swipe} from "mirsahib-react-swipe-component";
import {randomIdentifier} from "../../../utils/helpers";



type Props = {
    id: String,
    show: boolean,
    handleClose: any,
    scrollable: boolean,
    bodyStyle: Object,
    headingStyle: Object,
    style: Object,
    title: String
};

const PopupComponent = ({
    id,
    show,
    handleClose,
    children,
    scrollable,
    bodyStyle,
    headingStyle,
    style,
    title
}: Props) => {

    const [isShow, setIsShow] = useState(show)

    useEffect(() => {
        setIsShow(show);
        if (id === 'MD6' && show) {
            document.body.style.overflow = "hidden";
        }

        return () => {
            if (id === 'MD6') {
                document.body.style.overflow = null;
            }
        }
    }, [show])

    const _handleClose = () => {
        setIsShow(false)
        if(typeof handleClose == 'function') handleClose(id, isShow)
    }

    return (
        <>
            <div className={"cs-popup"+ (isShow ? ' show' : '')} style={style}>
                <div className="cs-popup-content">
                    <div className="cs-popup-heading" style={headingStyle}>
                        <h3>{title}</h3>
                        <span onClick={_handleClose} className="cs-popup-close-btn">
                            <img src={"/images/icon_close_black.svg"}/>
                        </span>
                    </div>
                    <div className={"cs-popup-body" + (scrollable ? ' scrollable': '')} style={bodyStyle}>
                        {children}
                    </div>
                </div>
            </div>
            <div className={"cs-popup-overlay"}></div>
        </>
    );
};

PopupComponent.defaultProps = {
    id: randomIdentifier(),
    show: false,
    handleClose: false,
    scrollable: false,
    bodyStyle: {},
    headingStyle: {},
    style: {}
};


export default PopupComponent;
